import { createContext } from 'react';

import type { PaletteMode } from '@mui/material';

/** Color-mode control surfaced to the app shell (the app-bar toggle). */
export interface ThemeModeContextValue {
  /** Active palette mode. */
  mode: PaletteMode;
  /** Flip between light and dark. */
  toggleMode: () => void;
  /** Set the mode explicitly. */
  setMode: (mode: PaletteMode) => void;
}

/**
 * Holds the active color mode. Provided by `app/providers/ThemeProvider`; read via
 * `useThemeMode()`. Split from the provider component so Fast Refresh stays happy.
 */
export const ThemeModeContext = createContext<ThemeModeContextValue | null>(null);
